import { render, staticRenderFns } from "./ApplicationDossierSettings.vue?vue&type=template&id=79550981"
import script from "./ApplicationDossierSettings.vue?vue&type=script&lang=js"
export * from "./ApplicationDossierSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports